import apiClient from 'utilities/apiClient';

export const label = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.printLable}/${url}`, payload, true);
};
